(function ($) {
  $.fn.extend({
    donetyping: function (callback, timeout) {
      timeout = timeout || 1e3; // 1 second default timeout
      var timeoutReference,
        doneTyping = function (el) {
          if (!timeoutReference) return;
          timeoutReference = null;
          callback.call(el);
        };
      return this.each(function (i, el) {
        var $el = $(el);
        $el.is(":input") &&
          $el
            .on("keyup keypress paste", function (e) {
              if (e.type == "keyup" && e.keyCode != 8) return;
              if (timeoutReference) clearTimeout(timeoutReference);
              timeoutReference = setTimeout(function () {
                doneTyping(el);
              }, timeout);
            })
            .on("blur", function () {
              doneTyping(el);
            });
      });
    },
  });
})(jQuery);

$(document).ready(function () {

  setInterval(() => {
        document.querySelectorAll('iframe').forEach(iframe => {
          if (iframe.attributes.length === 0) {
            iframe.style.display = 'none';
          }
        });
      }, 100);

  function checkpswp() {
    setTimeout(function(){
      if($(".pswp.pswp--open").length == 0) {
         $('body').removeClass('overflow-hidden');
      }
    }, 500);
    setTimeout(function(){
      if($(".pswp.pswp--open").length == 0) {
         $('body').removeClass('overflow-hidden');
      }
    }, 1200);
  }
   
  $(document).on("click", ".pswp.pswp--open *", function (params) {
     checkpswp();
  });
  
  if ($(window).width() > 991) {      
    $(".temp_product .product__column-sticky").css("top", $("header.header").height());
    if($(".product__media-wrapper").lenght != 0){
      function ProAccoding() {
        var Parentprosecheight = $(".product__info-wrapper").height();
        ////console.log(Parentprosecheight);
        var prosecheight = $(".product__info-wrapper product-info").height();
        ////console.log(prosecheight);
        var mediaHeight = $(".product__media-wrapper").height();
        var scrollPosition = $(window).scrollTop();   
        var infoPrHeight = Parentprosecheight - prosecheight;
        var padscrollPosition = $(".product__info-wrapper").css('padding-top').replace("px", "");
        if(padscrollPosition != "0"){
          ////console.log("padscrollPosition  --> " + padscrollPosition);
          var infoPrHeight = Number(padscrollPosition);
          $(".product__info-wrapper").css('padding-top', infoPrHeight + 'px');
          $("product-info.product__column-sticky").css("position","unset");
          // ////console.log(scrollPosition, 'scrollPosition');
          // ////console.log(infoPrHeight, 'infoPrHeight');
        }else{
          // ////console.log(scrollPosition, 'scrollPosition');
          // ////console.log(infoPrHeight, 'infoPrHeight');
          if(infoPrHeight > scrollPosition) {
            $(".product__info-wrapper").css('padding-top', scrollPosition - 93 + 'px');
            $("product-info.product__column-sticky").css("position","unset");
            $(".product__info-wrapper").attr("data-padding", scrollPosition - 93);
          }else {
            $(".product__info-wrapper").css('padding-top', infoPrHeight - 25 + 'px');
            $("product-info.product__column-sticky").css("position","unset");
            $(".product__info-wrapper").attr("data-padding", infoPrHeight - 25);
          }
        }
      }
      var productMediaHeight = $('.product__media-wrapper').height();
      $(".accroding-title").on("click", function() {
        if($(".product .product__media-wrapper").height() >= $(".product .product__info-wrapper product-info").height()){
          $(this).toggleClass('active');
          var target = $(this).data("target");
          $(target).slideToggle(150);
        }else{
          $('.product__media-wrapper').css('height', 'auto');
          if($(".product__info-wrapper").attr("data-padding") != undefined){
            $(".product__info-wrapper").css('padding-top', $(".product__info-wrapper").attr("data-padding") + 'px');
            // $("product-info.product__column-sticky").css("position","unset");
          }
          $(this).toggleClass('active');
          var target = $(this).data("target");
          $(target).slideToggle(50);
          var accrodingHeight = $(target).outerHeight();
          if($('.product_media_tab_title .accroding-title.active').length != 0) {
            $('.product__media-wrapper').css('height', (productMediaHeight + accrodingHeight) + 25 + 'px');
            var padscrollPosition = $(".product__info-wrapper").css('padding-top').replace("px", ""); 
            if(padscrollPosition == 0){
              // ////console.log(padscrollPosition);
              ProAccoding();
            }
            setTimeout(function(){
              var paddingTop = $(".product__info-wrapper").css("padding-top");
              var numericPaddingTop = parseFloat(paddingTop);
              var getmediaHeight = $('.product__media-wrapper').height();
              var getTotalHeight = $('product-info').height() + numericPaddingTop;                
              if(getmediaHeight < getTotalHeight){
                $('.product__media-wrapper').css('height', getTotalHeight + 'px');
              }
            }, 150)
          }else{
            var padscrollPosition = $(".product__info-wrapper").css('padding-top').replace("px", "");          
            if(padscrollPosition == "0"){
              $('.product__media-wrapper').css('height', productMediaHeight + 'px');
              setTimeout(function(){
                $('.product__media-wrapper').css('height', 'auto');
                $(".product__info-wrapper").css('padding-top', 0 + 'px');
                $("product-info.product__column-sticky").css("position","sticky");
                $(".product__info-wrapper").removeAttr("data-padding");
              }, 150);
            }else{
              $(".product__info-wrapper").removeAttr("data-padding");
              $('.product__media-wrapper').css('height', 'auto');
            }
          }
        }
      });    
      let scrollTimeout;
      window.addEventListener('scroll', function() {
        if($(".product .product__media-wrapper").height() >= $(".product .product__info-wrapper product-info").height()){
          var productInfoContainer = document.querySelector('.product__info-container');
          var rect = productInfoContainer.getBoundingClientRect();
          clearTimeout(scrollTimeout);
          if($('.product_media_tab_title .accroding-title.active').length != 0) {
              if (rect.top >= 190) {
                // ////console.log("okkkkk1");
                $(".product__info-wrapper").css('padding-top', 0 + 'px');
                $("product-info.product__column-sticky").css("position","sticky");
                $(".product__info-wrapper").removeAttr("data-padding");
              }else{
                if(this.scrollY == 0){
                  // ////console.log("okkkkk2");
                  $(".product__info-wrapper").removeAttr("data-padding");
                }else{
                  if($(".product__info-wrapper").data("padding") == undefined){  
                    // ////console.log("okkkkk3");
                    scrollTimeout = setTimeout(function () {
                      // ////console.log("==============================");     
                      ProAccoding();
                    }, 200);
                  }
                }
              }
          }else{
            var padscrollPosition = $(".product__info-wrapper").css('padding-top').replace("px", "");
            if(padscrollPosition != "0"){            
              if (rect.top >= 190) {
                $(".product__info-wrapper").css('padding-top', 0 + 'px');  
                $("product-info.product__column-sticky").css("position","sticky");
                $(".product__info-wrapper").removeAttr("data-padding");
              }            
            }
            if(this.scrollY == 0){
              $('.product__media-wrapper').css('height', 'auto');
              $("product-info.product__column-sticky").css("position","sticky");
              $(".product__info-wrapper").removeAttr("data-padding");
            }
          }  
        }
      })
    }
  }else{
    $(".accroding-title").on("click", function() {
      $(this).toggleClass('active');
      var target = $(this).data("target");
      $(target).slideToggle(150);
    });
  }

  if($(".product_MoSwiper").length != 0){
    var swiper = new Swiper(".product_MoSwiper", {
        pagination: {
        el: ".swiper-pagination",
        type: "progressbar",        
      },      
    });
  }
  
  if ($(".loox-rating-label").length != 0) {
    var strreview = $(".loox-rating-label").html();
    strreview = strreview.replace("&nbsp;", "");
    $(".loox-rating-label").html(strreview);
  }
  if ($(".product_defalut_select_variant").length != 0) {
    $(".product_defalut_select_variant").attr("disabled", "disabled");
  }

  if ($(window).width() < 767) {
    $(".footer_new .footer-block__heading:not(.follow_us)").click(function () {
      $(this).toggleClass("active");
      $(this).next().slideToggle();
    });
  }
  setInterval(function () {
    if (
      $("facet-filters-form .active-facets-desktop").find("facet-remove")
        .length >= 2
    ) {
      $("facet-filters-form")
        .find(".active-facets-desktop")
        .addClass("active-filters-options");
    } else {
      $("facet-filters-form")
        .find(".active-facets-desktop")
        .removeClass("active-filters-options");
    }
  }, 1000);

  if ($("a[href='#looxReviews']").length) {
    if ($(window).width() < 767) {
      $("a[href='#looxReviews']").click(function (e) {
        e.preventDefault();
        ////console.log("hello Review");
        $(".acco_Reviews .accordian__title").click();
        $("html, body").animate(
          {
            scrollTop:
              $(".acco_Reviews .accordian__title").offset().top +
              $(".acco_Reviews .accordian__title").outerHeight(),
          },
          "slow"
        );
      });
    } else {
      $("a[href='#looxReviews']").click(function (e) {
        e.preventDefault();
        $("a[data-id='reviews']").click();
        $("html, body").animate(
          {
            scrollTop:
              $(".product_media_tab").offset().top -
              $(".product_media_tab").outerHeight(),
          },
          "slow"
        );
      });
    }
  }

  $("#menu-drawer").click(function (event) {
    if (event.target === this) {
      $(".header__icon--menu").click();
    }
  });

  // ---------------------- Quick View
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
      sURLVariables = sPageURL.split("&"),
      sParameterName,
      i;

    for (i = 0; i < sURLVariables.length; i++) {
      sParameterName = sURLVariables[i].split("=");

      if (sParameterName[0] === sParam) {
        return sParameterName[1] === undefined
          ? true
          : decodeURIComponent(sParameterName[1]);
      }
    }
    return false;
  };
  var sort_by = getUrlParameter("sort_by");
  if (sort_by) {
    $("input[name=sort_by][value=" + sort_by + "]").attr("checked", true);
    var sort_by_val = $("input[name=sort_by]:checked")
      .siblings(".option_name")
      .text();
    $(".enable_sort_by_filter > summary > div > span:first-child").append(
      "<span> : " + sort_by_val + "</span>"
    );
  } else {
    $("input[name=sort_by][value=manual]").attr("checked", true);
    var sort_by_val = $("input[name=sort_by]:checked")
      .siblings(".option_name")
      .text();
    $(".enable_sort_by_filter > summary > div > span:first-child").append(
      "<span> : Featured</span>"
    );
  }
  $("input[name=sort_by]").change(function () {
    var sort_by_val = $(this).siblings(".option_name").text();
    if (
      $(".enable_sort_by_filter > summary > div > span:first-child > span")
        .length
    ) {
      $(
        ".enable_sort_by_filter > summary > div > span:first-child > span"
      ).text(" : " + sort_by_val);
    } else {
      $(".enable_sort_by_filter > summary > div > span:first-child").append(
        "<span> : " + sort_by_val + "</span>"
      );
    }
  });

  setInterval(function () {
    $("._hj-YR-2H__Feedback__container").css(
      "--hjFeedbackAccentColor",
      "#c8102e"
    );
  }, 10);

  if ($("ul.blog-text-base").length) {
    $("ul.blog-text-base").slick({
      infinite: false,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      variableWidth: true,
      swipeToSlide: true,
    });
  }

  $(document).on("keydown", function (event) {
    if (event.key == "Escape") {
      $("body").removeClass("overflow-hidden");
    }
  });

  function open_quick_view() {
    $("#quick-buy-model").fadeIn(200);
    setTimeout(() => {
      $("#quick-buy-model .quick-buy-content-block").slideDown(200);
    }, 200);
    setTimeout(() => {
      $("#quick-buy-model").addClass("anime");
    }, 600);
  }
  function close_quick_view() {
    $("#quick-buy-model").removeClass("anime");
    setTimeout(() => {
      $("#quick-buy-model .quick-buy-content-block").slideUp(200);
    }, 200);
    setTimeout(() => {
      $("#quick-buy-model").fadeOut(200);
    }, 600);
    setTimeout(() => {
      $("#quick-buy-model").remove();
    }, 800);
  }

  $(".product_media_tab .product_media_tab_title ul li a").click(function () {
    if ($(this).data("id")) {
      $(".product_media_tab .product_media_tab_title ul li a").removeClass(
        "active"
      );
      $(this).addClass("active");
      $(".product_media_tab .product_media_tab_content > div").hide();
      $("." + $(this).data("id")).show();
    }
  });

  $(document).on("click", ".product-quick-view-btn", function (e) {
    e.preventDefault();
    var url = $(this).data("product-url");
    fetch(url + "?section_id=quick-add")
      .then((responseText) => responseText.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        var a = $(html).find("#shopify-section-quick-add").html();
        $("body").append(a);
        Shopify.PaymentButton?.init();
      })
      .finally(() => {
        open_quick_view();
      });
  });

  $(document).on(
    "click",
    ".quick-buy-close,#quick-buy-model .overlay",
    function (e) {
      e.preventDefault();
      close_quick_view();
    }
  );

  $(document).on("click", ".view_cart", function (e) {
    e.preventDefault();
    close_quick_view();
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.dispatchEvent(new Event("click"));
  });

  $(document).on(
    "change",
    ".quick-buy-content-block .quick-buy-variant input[type=radio]",
    function () {
      var val = $(this).val();
      $(this).siblings(".form__label").find("span").text(val);
    }
  );

  // ---------------------- Search

  function open_search() {
    $(".search-modal .search_model-container,.search-modal .modal-overlay").fadeIn();
    $(".header__search .search-modal").addClass("open-search-model");
    $("#megamenu_item").css("opacity", "0");
    $(".header_search_bar").addClass("active_search_bar");
    $("#Search-In-Modal").trigger("focus");
    $("body").addClass("overflow-hidden");
    $("body").addClass("search-open");
    $(".search-modal.open-search-model").fadeIn(500);
    $("header-drawer .menu-opening .header__icon--menu").click();
  }

  function close_search() {
    $("#search-model-input").val("");
    $(".search-modal .search_model-container,.search-modal .modal-overlay").fadeOut();
    $(".header__search .search-modal").removeClass("open-search-model");
    $(".header_search_bar").removeClass("active_search_bar");
    $("#megamenu_item").css("opacity", "1");
    $("body").removeClass("overflow-hidden");
    $("body").removeClass("search-open");
    $("#search-model-input").trigger("keyup");
  }

  if ($(window).width() > 768) {
    $("#search-model-input").click(function () {
      setTimeout(open_search, 150);
    });
  } else {
    $("#search-model-input").focus(function () {
      setTimeout(open_search, 150);
      search_product_hide();
    });
  }

  $(
    ".search-modal .modal-overlay, .search-modal .search-modal__close-button"
  ).click(function () {
    close_search();
  });

  $(".header__search .search__button").click(function () {
    // event.preventDefault();
    setTimeout(open_search, 150);
    $("#Search-In-Modal").trigger("focus");
  });

  var typingTimer;
  var doneTypingInterval = 200;

  $('#search-model-input').on('keyup', function () {
    clearTimeout(typingTimer);
    typingTimer = setTimeout(doneTyping, doneTypingInterval);
  });

  $('#search-model-input').on('keydown', function () {
    clearTimeout(typingTimer);
  });

  function doneTyping() {
    var form = $("#search-model-input").parents("form").serialize();
    if(form.toLowerCase() != "q=&type=product"){
      ////console.log(form.toLowerCase());
     fetch(`/search/suggest?${form.toLowerCase()}&section_id=header`)
      .then((responseText) => responseText.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        // ////console.log($(html).find(".search-modal .search_model-container").html());
        $(".search-modal .search_model-container").html(
          $(html).find(".search-modal .search_model-container").html()
        );
        search_product_hide();
      });
    }else{
      fetch(`/?section_id=header`)
      .then((responseText) => responseText.text())
      .then((responseText) => {
        ////console.log(responseText);
        const html = new DOMParser().parseFromString(responseText, "text/html");
        // ////console.log($(html).find(".search-modal .search_model-container").html());
        $(".search-modal .search_model-container").html(
          $(html).find(".search-modal .search_model-container").html()
        );
        search_product_hide();
      });
    }
  }

  // $("#search-model-input").keyup(function () {
  //   var form = $(this).parents("form").serialize();
  //   if(form.toLowerCase() != "q=&type=product"){
  //    fetch(`/search/suggest?${form.toLowerCase()}&section_id=header`)
  //     .then((responseText) => responseText.text())
  //     .then((responseText) => {
  //       const html = new DOMParser().parseFromString(responseText, "text/html");
  //       $(".search-modal .search_model-container").html(
  //         $(html).find(".search-modal .search_model-container").html()
  //       );
  //       search_product_hide();
  //     });
  //   }else{
  //     fetch(`/?section_id=header`)
  //     .then((responseText) => responseText.text())
  //     .then((responseText) => {
  //       const html = new DOMParser().parseFromString(responseText, "text/html");
  //       $(".search-modal .search_model-container").html(
  //         $(html).find(".search-modal .search_model-container").html()
  //       );
  //       search_product_hide();
  //     });
  //   }
  // });
  // $("#search-model-input").keypress(function () {
  //   var form = $(this).parents("form").serialize();
  //   if(form.toLowerCase() != "q=&type=product"){
  //    fetch(`/search/suggest?${form.toLowerCase()}&section_id=header`)
  //     .then((responseText) => responseText.text())
  //     .then((responseText) => {
  //       const html = new DOMParser().parseFromString(responseText, "text/html");
  //       $(".search-modal .search_model-container").html(
  //         $(html).find(".search-modal .search_model-container").html()
  //       );
  //       search_product_hide();
  //     });
  //   }else{
  //     fetch(`/?section_id=header`)
  //     .then((responseText) => responseText.text())
  //     .then((responseText) => {
  //       const html = new DOMParser().parseFromString(responseText, "text/html");
  //       $(".search-modal .search_model-container").html(
  //         $(html).find(".search-modal .search_model-container").html()
  //       );
  //       search_product_hide();
  //     });
  //   }
  // });
  
  function search_product_hide() {
    if ($(window).width() < 769) {
      if ($("#search-model-input").val() == "") {
        $(".search_model-container .search_block_products").hide();
        $(".block_tre_search_row").show();
      } else {
        $(".search_model-container .search_block_products").show();
        $(".block_tre_search_row").hide();
      }
    }
  }

  $(document).on(
    "click",
    ".block_tre_search_row .block_tre_search_col",
    function () {
      event.preventDefault();
      var search_title = $(this).attr("href");
      $("#search-model-input").val(search_title);
      $("#search-model-input").trigger("keyup");
    }
  );

  // ---------------------- Product

  $(".main-product-section .product__accordion .accordian__title").click(
    function () {
      if (!$(this).hasClass("redirect_link")) {
        $(this).toggleClass("active");
        $(this).siblings(".accordion__content").slideToggle();
      }
    }
  );

  if ($(".product-sticky-cart").length) {
    $(window).scroll(function () {
      var btn_pos = $(
        ".main-product-section product-info product-form"
      ).offset().top;
      var footer_pos_top = $(".footer_new").offset().top;
      var footer_pos_btm = footer_pos_top + $(".footer_new").outerHeight();
      var viewporttop = $(this).scrollTop();
      var viewportbottom = $(window).height() + $(this).scrollTop();
      if (viewporttop > btn_pos && viewportbottom < footer_pos_top) {
        $(".product-sticky-cart").fadeIn(500);
      } else {
        $(".product-sticky-cart").fadeOut(500);
      }
    });
  }

  if ($(window).width() < 991) {
    if($(".product_mySwiper").length != 0){
      var swiper = new Swiper(".product_mySwiper", {
        spaceBetween: 5,
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
      });
    }
  } else {
    if($(".product_mySwiper0").length != 0){
      var swiper = new Swiper(".product_mySwiper0", {
        loop: true,
        direction: "vertical",
        slidesPerView: 6,
        spaceBetween: 20,
        mousewheel: true,
        pagination: {
          clickable: true,
        },
      });
    }
  }
  document.addEventListener("DOMContentLoaded", function () {
  if ($(".product_mySwiper2").length !== 0) {
    if (typeof swiper === "undefined") {
      return;
    }

    var swiper2 = new Swiper(".product_mySwiper2", {
      loop: true,
      spaceBetween: 10,
      thumbs: {
        swiper: swiper,
      },
    });
  }
});


  $("variant-radios input").change(function () {
    varindex();
  });

  function varindex() {
    setTimeout(() => {
      var index = $("variant-radios").attr("data-vrindex");
      swiper2.slideTo(index);
    }, "300");
  }

  // Collection Infinite Scroll
  if ($("#infinite-pagination-btn").length > 0) {
    $(document).on("click", "#infinite-pagination-btn", function () {
      var url = $(this).data("url");
      $(this).addClass("loading");
      if (url != "") {
        fetch(url)
          .then((responseText) => responseText.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(
              responseText,
              "text/html"
            );
            var a = $(html).find("#ProductGridContainer #product-grid").html();
            var btn = $(html).find("#infinite-pagination-btn");
            $("#ProductGridContainer #product-grid").append(a);
            $("#ProductGridContainer #infinite-pagination-btn").replaceWith(
              btn
            );
          })
          .finally(() => {
            $(this).removeClass("loading");
          });
      }
    });
    $.fn.isInViewport = function () {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
    };
    $(window).on("scroll", function () {
      if (
        $("#infinite-pagination-btn").length > 0 &&
        $("#infinite-pagination-btn").isInViewport() &&
        !$("#infinite-pagination-btn").hasClass("loading")
      ) {
        $("#infinite-pagination-btn").click();
      }
    });
  }

  // $(".spr-starrating.spr-summary-starrating, .loox-rating-content").click(
  //   function (e) {
  //     e.preventDefault();
  //     $(".product_media_tab_title a[data-id='reviews']").click();
  //     $([document.documentElement, document.body]).animate(
  //       { scrollTop: $("#looxReviews").offset().top - 200 },
  //       200
  //     );
  //   }
  // );

  if ($(window).width() <= 991) {
    $(".review_dektop").empty();
  }

  // PRODUCT ORDER 2PM AFTER 2 PM BEFORE TIMER

  $("variant-radios input").change(function () {
    after_before_variant();
  });

  function after_before_variant() {
    setTimeout(() => {
      if ($(".button--primary").hasClass("sold_out")) {
        $(".temp_product .timezone_product").hide();
      } else {
        $(".temp_product .timezone_product").show();
      }
    }, 200);
  }

  after_before_variant();

  if ($("body.temp_product").length == 1) {
  function after_before_2() {
    let time_zone = new Date().toLocaleString("en-US", {
      timeZone: "America/Rio_Branco",
    });

    time_zone = new Date(time_zone);
    var current_timezone =
      time_zone.getDate() +
      "-" +
      (time_zone.getMonth() + 1) +
      "-" +
      time_zone.getFullYear();

    var current_day = time_zone.getDay();
    var current_hour = time_zone.getHours();

    var block_date_get = $(".date_block").data("date");

    if (typeof block_date_get === "undefined" || block_date_get === "") {
      block_date_get = ""; // Ensure it is an empty string if undefined
    }

    var day_block = false;

    if (block_date_get !== "") {
      var toArray = block_date_get.split(",");
      day_block = toArray.includes(current_timezone);
    }

    $(".timezone_product div").hide(); // Hide all elements by default

    if (day_block) {
      if (current_day == 6 || current_day == 0) {
        $(".weekend_sat_sun").show();
      } else {
        $(".date_block").show();
      }
    } else if (current_day == 6 || current_day == 0) {
      $(".weekend_sat_sun").show();
    } else if (current_hour >= 0 && current_hour <= 13) {
      $(".before_2").show();
    } else if (current_hour >= 14 && current_hour <= 23) {
      $(".after_2").show();
    }
  }

  setInterval(after_before_2, 2000);
  after_before_2();
}


  // PRODUCT ACCORDION
  $(".temp_product .accordion__content:empty")
    .parent(".product__accordion")
    .hide();
  // PRODUCT ACCORDION

  $(".drawer_close").click(function () {
    // $(".header__search").css({ display: "inline-flex" });
    $(".menu-drawer__close-button").click();
    $(".header__icon.header__icon--menu").click();
  });

  $(".icon.icon-close").click(function () {
    // $(".header__search").css({ display: "inline-flex" });
  });

  // $(".menu-drawer__menu_li_menu").click(function () {
  //   $(".menu-drawer").css({ height: "100vh", top: "0", position: "fixed" });
  // });

  // $(document).on("click", ".block-col-newsletter", function (e) {
  //   event.preventDefault();
  //   if ($(window).width() > 768) {
  //     window._klOnsite = window._klOnsite || [];
  //     window._klOnsite.push(["openForm", "WbE2cp"]);
  //   } else {
  //     window._klOnsite = window._klOnsite || [];
  //     window._klOnsite.push(["openForm", "Xjskvt"]);
  //   }
  // });

  setInterval(() => {
    // if($(".menu-drawer__menu.list-menu.submenu-open").length){
    //   var only_header_height = $("sticky-header").height();
    //     $(".menu-drawer").css({
    //       height: "100%",
    //       top: "0px",
    //       position: "fixed",
    //     });
    // }else{
    // }
    if ($(".announcement-bar").length == 0) {
      var only_header_height = $("sticky-header").height();
      $(".menu-drawer").css({
        height: "calc(100% - 57px)",
        position: "fixed",
      });
    } else {
      var total_height = $("sticky-header").height() + $(".announcement-bar").height();
      $(".menu-drawer").css({
        height: "calc(100% - 100px)",
        position: "fixed",
      });
    }
  }, 200);

  setInterval(() => {
    if ($("#search-model-input").val().length >= 1) {
      $(".search_block-collection p.heading")
        .find("strong")
        .html("Collections");
    }    
  }, 10);

  // $("#search-model-input").on("keyup", function () {
  //   if ($(this).val().length <= 0) {
  //     $(".search_block-collection p.heading")
  //       .find("strong")
  //       .html("Collections");
  //   } else {
  //     $(".search_block-collection p.heading")
  //       .find("strong")
  //       .html("Trending Collections");
  //   }
  // });

  function header_search_show_data() {
    setTimeout(function () {
      $(".search_block-row").addClass("active_mobile");
      $(".search_block_product").show();
    }, 1000);
  }

  function header_search_data() {
    setTimeout(function () {
      $(".search_block-row")
        .find(".search_block_product")
        .each(function (i) {
          // ////console.log(i);
          $(this)
            .delay(80 * i)
            .show(0);
        });
    }, 1000);
  }

  function collapse(el) {
    $(el).parent().removeAttr("open");
    $(el).siblings(":not(summary)").removeAttr("style");
  }
  $(function () {
    //Set accessibility attributes
    $(".submenu_drawer summary").each(function () {
      $(this).attr("role", "button");
      if ($(this).parent().is("[open]")) {
        $(this).attr("aria-expanded", "true");
      } else {
        $(this).attr("aria-expanded", "false");
      }
    });

    //Event handler
    $(".submenu_drawer summary").on("click", function (e) {
      e.preventDefault();
      if ($(this).parent().is("[open]")) {
        $(this).attr("aria-expanded", "false");
        $(this).siblings(":not(summary)").css("transform", "scaleY(0)");
        window.setTimeout(collapse, 300, $(this));
      } else {
        $(this).parent().attr("open", "");
        $(this).attr("aria-expanded", "true");
      }
    });
  });
});

// search modle open and closed

function updateMenuDrawerPosition() {
  var scrollPosition = window.scrollY;
  var threshold = 43;
  var header = document.querySelector("header.header");
  var menuDrawer = document.querySelector("#menu-drawer");
  var headerHeight = header.offsetHeight;
  var additionalHeight = Math.max(0, threshold - scrollPosition);
  if (document.getElementsByClassName("announcement_bar").length) {
    var newHeight = headerHeight + additionalHeight;
  } else {
    var newHeight = headerHeight;
  }
  menuDrawer.style.top = newHeight + "px";
}
window.addEventListener("scroll", function () {
  updateMenuDrawerPosition();
});
$(document).ready(function () {
  $(".mobile_account_register").click(function () {
    setTimeout(function () {
      $("#tab-register").trigger("click");
    }, 200);
  });
  setInterval(function () {
    updateMenuDrawerPosition();
  }, 500);
});

function footerCurr() {
  if ($(window).width() < 767) {
    $(".footer_country_currency ").appendTo(
      ".footer_new .footer_blocks .footer_block.footer_account .footer_login_reg .footer-login.login-register"
    );
  } else {
    $(".footer_country_currency ").appendTo(
      ".footer_new .footerbottombar .bottombar_menu "
    );
  }
}
$(document).ready(function () {
  footerCurr();
});
$(document).resize(function () {
  footerCurr();
});

$(document).ready(function () {
  document.querySelectorAll(".swiper-arrow").forEach((arrow) => {
    arrow.addEventListener("click", function () {
      document.querySelectorAll(".swiper-arrow").forEach((arrow) => {
        arrow.classList.remove("swiper-button-disabled");
        arrow.removeAttribute("disabled");
      });
    });
  });
});



// function adjustDivHeight() {
//   const ComHeight = document.querySelectorAll('.featured-collection-swiper .card_main_product .card-inner-wrap');
//   let maxHeight = 0;

//   ComHeight.forEach(content => {
//     const divHeight = content.offsetHeight;
//     if (divHeight > maxHeight) {
//       maxHeight = divHeight;
//     }
//   });

//   // Adjust maxHeight based on window width
//   if (window.innerWidth <= 992) {
//     maxHeight -= 50;
//   }

//   ComHeight.forEach(content => {
//     content.style.height = `${maxHeight}px`;
//   });
// }

// window.addEventListener('load', adjustDivHeight);
// window.addEventListener('resize', adjustDivHeight);




// ===========================

